module.exports = __webpack_public_path__ + "log-in/img/membership-core.0233f47a.svg";